<template>
  <SeoPage page-key="socialMediaManagementTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'SocialMediaManagementTicinoPage'
})
</script>

